import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import CmsTokenBootstrap from './cms-token-bootstrap';
/** Standalone dev shell — CMS token is fetched automatically; wallet APIs need the base host demo. */
const StandaloneCmsShell = () => _jsx(CmsTokenBootstrap, {});
export default StandaloneCmsShell;
